/* R&B dropdowns: every <select> on the site opens our own list instead of the browser's.
   The real <select> stays in the page (forms, Shopify scripts and validation keep working); we only replace the
   picker. Desktop: a small panel under (or above) the field. Phones: a sheet from the bottom.
   Opt out on a field with data-native. Keyboard: Enter/Space/Down opens, arrows move, Enter picks, Esc closes,
   typing jumps to an option; long lists get a search field. Calm motion (0.34 s), none with reduced motion. */
(function () {
  if (window.RbSelect) return;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var open = null; // { select, btn, pop, list, items, idx, sheet }

  function eligible(s) {
    return s && s.tagName === 'SELECT' && !s.multiple && !(s.size > 1) && !s.hasAttribute('data-native') && !s.closest('[data-native]') && !s.dataset.rbSelect;
  }
  function labelFor(s) {
    var l = s.id && document.querySelector('label[for="' + s.id + '"]');
    return (l && l.textContent.trim()) || s.getAttribute('aria-label') || s.getAttribute('name') || '';
  }
  function current(s) { var o = s.options[s.selectedIndex]; return o ? o.text.trim() : ''; }

  function enhance(s) {
    if (!eligible(s)) return;
    s.dataset.rbSelect = '1';
    var cs = getComputedStyle(s);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rb-dd__hit';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    function name() { btn.setAttribute('aria-label', (labelFor(s) ? labelFor(s) + ': ' : '') + current(s)); }
    name();
    if (cs.position === 'absolute') {
      // already laid over its text (country / language switcher): the button takes its place
      s.parentNode.insertBefore(btn, s.nextSibling);
    } else {
      var wrap = document.createElement('span');
      wrap.className = 'rb-dd';
      var full = cs.display === 'block' || cs.display === 'flex' || (s.parentNode && s.offsetWidth >= s.parentNode.clientWidth - 1);
      wrap.style.display = full ? 'block' : 'inline-block';
      s.parentNode.insertBefore(wrap, s);
      wrap.appendChild(s);
      wrap.appendChild(btn);
    }
    s.tabIndex = -1;
    s.setAttribute('aria-hidden', 'true');
    s.addEventListener('change', name);
    btn.addEventListener('click', function () { if (open && open.select === s) close(true); else show(s, btn); });
    btn.addEventListener('keydown', function (e) {
      if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].indexOf(e.key) > -1) { e.preventDefault(); show(s, btn); }
    });
    if (s.form) s.form.addEventListener('reset', function () { setTimeout(name, 0); });
  }

  function build(s) {
    var pop = document.createElement('div');
    var sheet = window.matchMedia('(max-width: 749px)').matches;
    pop.className = 'rb-dd__pop' + (sheet ? ' rb-dd__pop--sheet' : '');
    var head = labelFor(s);
    var many = s.options.length > 14;
    pop.innerHTML = (sheet ? '<div class="rb-dd__head"><span>' + esc(head) + '</span><button type="button" class="rb-dd__x" aria-label="Close">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor"><path d="M1 1l12 12M13 1L1 13"/></svg></button></div>' : '')
      + (many ? '<div class="rb-dd__search"><input type="search" autocomplete="off" spellcheck="false" placeholder="' + esc(head || '') + '" aria-label="' + esc(head) + '"></div>' : '')
      + '<ul class="rb-dd__list" role="listbox" tabindex="-1" aria-label="' + esc(head) + '"></ul>';
    var list = pop.querySelector('ul');
    Array.prototype.forEach.call(s.options, function (o, i) {
      if (o.hidden) return;
      var li = document.createElement('li');
      li.className = 'rb-dd__opt';
      li.setAttribute('role', 'option');
      li.id = 'RbDd' + i + '-' + Math.random().toString(36).slice(2, 7);
      li.dataset.i = i;
      li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
      if (o.disabled) li.setAttribute('aria-disabled', 'true');
      li.innerHTML = '<span>' + esc(o.text.trim()) + '</span>';
      list.appendChild(li);
    });
    if (sheet) { var veil = document.createElement('div'); veil.className = 'rb-dd__veil'; pop.veil = veil; }
    return { pop: pop, list: list, sheet: sheet };
  }

  function show(s, btn) {
    if (open) close(false);
    var b = build(s);
    document.body.appendChild(b.pop);
    if (b.pop.veil) { document.body.insertBefore(b.pop.veil, b.pop); b.pop.veil.addEventListener('click', function () { close(true); }); }
    var items = Array.prototype.slice.call(b.list.children);
    open = { select: s, btn: btn, pop: b.pop, list: b.list, items: items, idx: Math.max(0, items.findIndex(function (li) { return li.getAttribute('aria-selected') === 'true'; })), sheet: b.sheet };
    if (!b.sheet) place();
    btn.setAttribute('aria-expanded', 'true');
    b.list.addEventListener('click', function (e) { var li = e.target.closest('.rb-dd__opt'); if (li) pick(li); });
    b.list.addEventListener('mousemove', function (e) { var li = e.target.closest('.rb-dd__opt'); if (li) mark(open.items.indexOf(li), false); });
    b.pop.addEventListener('keydown', onKey);
    var x = b.pop.querySelector('.rb-dd__x'); if (x) x.addEventListener('click', function () { close(true); });
    var search = b.pop.querySelector('input');
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      open.items.forEach(function (li) { li.hidden = q && li.textContent.toLowerCase().indexOf(q) === -1; });
      var first = open.items.findIndex(function (li) { return !li.hidden; });
      if (first > -1) mark(first, true);
    });
    mark(open.idx, true);
    requestAnimationFrame(function () {
      b.pop.classList.add('is-open'); if (b.pop.veil) b.pop.veil.classList.add('is-open');
      if (search && !b.sheet) search.focus(); else b.list.focus();
    });
    if (b.sheet) document.documentElement.classList.add('rb-dd-lock');
  }

  function place() {
    var r = open.btn.getBoundingClientRect(), p = open.pop;
    var w = Math.min(Math.max(r.width, 240), 380);
    p.style.width = w + 'px';
    var left = Math.min(Math.max(8, r.left), window.innerWidth - w - 8);
    p.style.left = left + 'px';
    var h = Math.min(p.scrollHeight, 360), below = window.innerHeight - r.bottom, above = r.top;
    if (below < h + 16 && above > below) { p.style.top = ''; p.style.bottom = (window.innerHeight - r.top + 6) + 'px'; p.classList.add('is-up'); }
    else { p.style.bottom = ''; p.style.top = (r.bottom + 6) + 'px'; }
  }

  function mark(i, scroll) {
    if (!open || i < 0 || i >= open.items.length) return;
    open.items.forEach(function (li) { li.classList.remove('is-active'); });
    var li = open.items[i];
    li.classList.add('is-active');
    open.idx = i;
    open.list.setAttribute('aria-activedescendant', li.id);
    if (scroll) li.scrollIntoView({ block: 'nearest' });
  }

  function step(dir) {
    var i = open.idx;
    do { i += dir; } while (i >= 0 && i < open.items.length && (open.items[i].hidden || open.items[i].getAttribute('aria-disabled')));
    if (i >= 0 && i < open.items.length) mark(i, true);
  }

  var typed = '', typedT;
  function onKey(e) {
    if (!open) return;
    var inSearch = e.target.tagName === 'INPUT';
    if (e.key === 'Escape') { e.preventDefault(); close(true); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); step(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); step(-1); }
    else if (e.key === 'Home' && !inSearch) { e.preventDefault(); mark(0, true); }
    else if (e.key === 'End' && !inSearch) { e.preventDefault(); mark(open.items.length - 1, true); }
    else if (e.key === 'Enter' || (e.key === ' ' && !inSearch)) { e.preventDefault(); pick(open.items[open.idx]); }
    else if (e.key === 'Tab') { close(false); }
    else if (!inSearch && e.key.length === 1) {
      typed += e.key.toLowerCase(); clearTimeout(typedT); typedT = setTimeout(function () { typed = ''; }, 600);
      var j = open.items.findIndex(function (li) { return li.textContent.trim().toLowerCase().indexOf(typed) === 0; });
      if (j > -1) mark(j, true);
    }
  }

  function pick(li) {
    if (!li || li.getAttribute('aria-disabled')) return;
    var s = open.select, i = +li.dataset.i, changed = s.selectedIndex !== i;
    close(true);
    if (!changed) return;
    s.selectedIndex = i;
    s.dispatchEvent(new Event('input', { bubbles: true }));
    s.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function close(focusBack) {
    if (!open) return;
    var o = open; open = null;
    o.btn.setAttribute('aria-expanded', 'false');
    o.pop.classList.remove('is-open');
    if (o.pop.veil) o.pop.veil.classList.remove('is-open');
    document.documentElement.classList.remove('rb-dd-lock');
    setTimeout(function () { o.pop.remove(); if (o.pop.veil) o.pop.veil.remove(); }, 340);
    if (focusBack) o.btn.focus({ preventScroll: true });
  }

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  document.addEventListener('pointerdown', function (e) { if (open && !open.pop.contains(e.target) && e.target !== open.btn) close(false); }, true);
  window.addEventListener('resize', function () { if (open && !open.sheet) place(); });
  window.addEventListener('scroll', function () { if (open && !open.sheet) place(); }, { passive: true });

  function scan(root) { (root || document).querySelectorAll('select').forEach(enhance); }
  function start() {
    scan();
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'SELECT') enhance(n); else if (n.querySelectorAll) scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.RbSelect = { scan: scan, close: close };
})();
